import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { FEATURE_FLAGS } from 'common/constants';
import {
  AchievementsPage,
  AchievementsRoutes,
} from 'components/routes/lazy-routes.component';

// The existing My Health redesign flag selects the standalone destination.
// Keep the route stable while it loads so the legacy SDK route cannot redirect
// before the enabled value arrives.
export const AchievementsRouteElement = () => {
  const {
    data: isStandaloneAchievementsEnabled,
    isLoading,
    isError,
  } = useFeatureFlagQuery(FEATURE_FLAGS.MY_HEALTH_REDESIGN_ENABLED);

  if (isLoading) return <LoadingIndicator />;

  return isStandaloneAchievementsEnabled === true || isError ? (
    <AchievementsPage />
  ) : (
    <AchievementsRoutes />
  );
};
